import DefaultLayout from '../Layouts/DefaultLayout';

import BirthdayList from '../Components/BirthdayList';

function App() {
    return (
        <DefaultLayout>
            <div className="py-4 md:py-6 2xl:py-10">
                <div className="grid grid-cols-12 gap-4 md:mt-4 md:gap-6 2xl:gap-7.5">
                    <div className="col-span-12">
                        <h3 className="text-3xl lg:text-4xl text-secondary font-bold mb-4 lg:mb-8">Aniversariantes do mês</h3>

                        <BirthdayList />
                    </div>
                </div>
            </div>
        </DefaultLayout>
    );
}

export default App;
